import { inject, injectable } from "@launchtray/tsyringe-async";
import { GameModel } from "../../game/models/game/GameModel";
import { PlayerController } from "../../game/controllers/PlayerController";
import { SceneManager } from "scene-manager";
import { AdSceneFactory, InjectableFactories } from "../../../composition/InjectableFactories";
import { DeckModel } from "../../game/models/deck/DeckModel";

@injectable()
export class LoseController {
    public constructor(
        private readonly playerController: PlayerController,
        private readonly gameModel: GameModel,
        private readonly deckModel: DeckModel,
        private readonly sceneManager: SceneManager,
        @inject(InjectableFactories.AdSceneFactory) private readonly adSceneFactory: AdSceneFactory
    ) { }

    public getPlayerScore(): number {
        return this.playerController.getScore();
    }

    public async revive(): Promise<boolean> {
        this.gameModel.clearGamefield();
        const adScene = await this.adSceneFactory();
        const result = await this.sceneManager.showViewableAsync(adScene);
        if (result) {
            this.playerController.reduceRevival();
            this.playerController.resetShuffles();
            this.gameModel.deckModel.shuffle();
        }
        return result;
    }

    public continue(): void {
        this.gameModel.clearGamefield();
        this.playerController.resetRevivals();
        this.playerController.resetScore();
        this.deckModel.removeSpecialFigure();
        this.playerController.resetBoosters();
        this.gameModel.deckModel.shuffle();
    }

    public getBestScore(): number {
        return this.playerController.getBestScore();
    }

    public setBestScore(value: number): void {
        this.playerController.setBestScore(value);
    }

    public isHaveRevivals(): boolean {
        return this.playerController.isHaveRevivals();
    }
}